export const FreeShipMethodID = "16";
export const DefaultShipMethodID = "1";
export const FlatRateShipMethodID = "";
export const FreeEnrollmentItemID = "9999";
export const FreeEnrollmentZeroPriceItemID = "8888";
export const FreeEnrollmentZeroPriceItemID2 = "ENROLL009GUFOFOXSMOF";
export const DefaultCountry = "US";
export const CORPORATESTOREID = "1";
export const RETAILSTOREID = "3";
export const IBOSTOREID = "4";
export const AUTOSHIPSTOREID = "5";
export const MONTHLYFREQUENCYID = "2";
export const YEARLYFREQUENCYID = "4";